import { FORM_ID } from './constants';
import type {
    AuthInlineFormWithContextProviderProps as AuthInlineFormProps,
    AgreementsOnClick,
    AgreementsOnOpen,
} from './types';
import { AuthInlineFormProvider as AuthInlineFormComponent } from './ui/AuthInlineFormProvider';
import { BeforeSlot, AfterSlot } from './ui/Slots';
import { AdvertisingBanner } from './ui/AdvertisingBanner';
import { GiftBanner } from './ui/GiftBanner';

interface ICompoundedComponent
    extends React.ForwardRefExoticComponent<AuthInlineFormProps & React.RefAttributes<HTMLFormElement>> {
    Before: typeof BeforeSlot;
    After: typeof AfterSlot;
}

const CustomAuthInlineForm = AuthInlineFormComponent as ICompoundedComponent;

CustomAuthInlineForm.Before = BeforeSlot;
CustomAuthInlineForm.After = AfterSlot;

export type { AuthInlineFormProps, AgreementsOnClick, AgreementsOnOpen };
export { CustomAuthInlineForm, FORM_ID, AdvertisingBanner, GiftBanner };
